import { capitalize } from "vue";

import { SizeFormat, TshirtSize } from "~/shared/enums";

export const UNSIZED_SIZE_LABEL = "(Unsized)";

export const TSHIRT_SIZES_INCLUDING_NULL = [null, ...Object.values(TshirtSize)];

export const TSHIRT_SIZE_TO_LABEL = new Map(Object.entries(TshirtSize).map(([k, v]) => [v, k]));

export const TSHIRT_SIZE_TO_NUMBER_SIZE = new Map([
  [null, null],
  [TshirtSize.EXTRA_SMALL, 1],
  [TshirtSize.SMALL, 2],
  [TshirtSize.MEDIUM, 3],
  [TshirtSize.LARGE, 5],
  [TshirtSize.EXTRA_LARGE, 8],
]);

export const NUMBER_SIZES = Array.from(TSHIRT_SIZE_TO_NUMBER_SIZE.values());

export const NUMBER_SIZE_TO_TSHIRT_SIZE = new Map(
  Array.from(TSHIRT_SIZE_TO_NUMBER_SIZE.entries()).map(([k, v]) => [v, k])
);

export const TSHIRT_SIZE_TO_PRETTY_LABEL = new Map(
  Array.from(TSHIRT_SIZE_TO_NUMBER_SIZE.keys()).map((e) => {
    const title = e ? TSHIRT_SIZE_TO_LABEL.get(e) : null;
    return [e, title ? capitalize(title.replace("_", " ").toLowerCase()) : null];
  })
);

export const NUMBER_SIZE_TO_PRETTY_LABEL = new Map(
  Array.from(NUMBER_SIZE_TO_TSHIRT_SIZE.entries()).map(([k, v]) => [k, TSHIRT_SIZE_TO_PRETTY_LABEL.get(v)])
);

export const TSHIRT_SIZE_ORDER_FOR_NLP = [
  TshirtSize.EXTRA_SMALL,
  TshirtSize.EXTRA_LARGE,
  TshirtSize.SMALL,
  TshirtSize.MEDIUM,
  TshirtSize.LARGE,
];

const EXTRA_SMALL_COLOR = "#c7d2fe";
const SMALL_COLOR = "#818cf8";
const MEDIUM_COLOR = "#6366f1";
const LARGE_COLOR = "#4f46e5";
const EXTRA_LARGE_COLOR = "#3730a3";

export const TSHIRT_SIZE_COLOR_MAP = new Map([
  [TshirtSize.EXTRA_SMALL, EXTRA_SMALL_COLOR],
  [TshirtSize.SMALL, SMALL_COLOR],
  [TshirtSize.MEDIUM, MEDIUM_COLOR],
  [TshirtSize.LARGE, LARGE_COLOR],
  [TshirtSize.EXTRA_LARGE, EXTRA_LARGE_COLOR],
]);

export const FIBONACCI_SIZE_COLOR_MAP = new Map([
  [1, EXTRA_SMALL_COLOR],
  [2, SMALL_COLOR],
  [3, MEDIUM_COLOR],
  [5, LARGE_COLOR],
  [8, EXTRA_LARGE_COLOR],
]);

export const LINEAR_SIZE_COLOR_MAP = new Map([
  [1, EXTRA_SMALL_COLOR],
  [2, SMALL_COLOR],
  [3, MEDIUM_COLOR],
  [4, LARGE_COLOR],
  [5, EXTRA_LARGE_COLOR],
]);

export const EXPONENTIAL_SIZE_COLOR_MAP = new Map([
  [1, EXTRA_SMALL_COLOR],
  [2, SMALL_COLOR],
  [4, MEDIUM_COLOR],
  [8, LARGE_COLOR],
  [16, EXTRA_LARGE_COLOR],
]);

export const FREE_ENTRY_SIZE_COLOR_MAP = new Map([
  [1, EXTRA_SMALL_COLOR],
  [2, SMALL_COLOR],
  [3, SMALL_COLOR],
  [4, MEDIUM_COLOR],
  [5, MEDIUM_COLOR],
  [6, LARGE_COLOR],
  [7, LARGE_COLOR],
  [8, EXTRA_LARGE_COLOR],
]);

export const TSHIRT_SIZES = ["XS", "S", "M", "L", "XL"];

export const FIBONACCI_SIZES = [1, 2, 3, 5, 8];

export const EXPONENTIAL_SIZES = [1, 2, 4, 8, 16];

export const LINEAR_SIZES = [1, 2, 3, 4, 5];

export const FREE_ENTRY_LIMIT = 8;
export const FREE_ENTRY_SIZES = Array.from(Array(FREE_ENTRY_LIMIT).keys()).map((e) => e + 1);
export const FREE_ENTRY_LIMIT_LABEL = `>${FREE_ENTRY_LIMIT}`;

export const SIZE_FORMAT_TO_COLOR_MAP = new Map<SizeFormat, Map<number, string>>([
  [SizeFormat.TSHIRT, FIBONACCI_SIZE_COLOR_MAP],
  [SizeFormat.FIBONACCI, FIBONACCI_SIZE_COLOR_MAP],
  [SizeFormat.EXPONENTIAL, EXPONENTIAL_SIZE_COLOR_MAP],
  [SizeFormat.LINEAR, LINEAR_SIZE_COLOR_MAP],
  [SizeFormat.FREE_ENTRY, FREE_ENTRY_SIZE_COLOR_MAP],
]);

export const getSizeOptions = (sizes: number[]) => [
  { size: null, label: UNSIZED_SIZE_LABEL },
  ...sizes.map((size) => ({ size, label: size.toString() })),
];
